import { bootstrapApplication } from '@angular/platform-browser';
import {
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { HttpBackend, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideSignalFormsConfig } from '@angular/forms/signals';
import { provideTranslateService, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { firstValueFrom } from 'rxjs';
import { App } from './app/app';
import { routes } from './app/app.routes';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { baseUrlInterceptor } from '@core/interceptors/base-url.interceptor';

bootstrapApplication(App, {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'top' }),
    ),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, baseUrlInterceptor])),
    // Every [formField] control carries .is-invalid once touched and invalid; ppcInput paints it.
    provideSignalFormsConfig({
      classes: { 'is-invalid': (formField) => formField.state().touched() && formField.state().invalid() },
    }),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: (handler: HttpBackend) => new MultiTranslateHttpLoader(handler, ['/assets/i18n/']),
        deps: [HttpBackend],
      },
      fallbackLang: 'nl',
      lang: 'nl',
    }),
    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      translate.addLangs(['nl', 'en']);
      const stored = localStorage.getItem('ppc.lang');
      const lang = stored === 'nl' || stored === 'en' ? stored : 'nl';
      document.documentElement.lang = lang;
      return firstValueFrom(translate.use(lang));
    }),
  ],
}).catch((err) => console.error(err));
